import "//shopakaso.com/cdn/shop/t/25/assets/swiper@11.min.js?v=104684603862494721831780911930"
import "//shopakaso.com/cdn/shop/t/25/assets/jquery.js?v=147293088974801289311780911872"

/**
 * 追踪订单
 * @param  body 
 */
async function trackOrder(body) {
  const data = new FormData()
  Object.keys(body).forEach(key => {
    data.append(key, body[key]);
  });
  return new Promise((resolve, reject) => {
    $.ajax({
      type: "POST",
      url: 'https://www.akasotech.com/shopifyApi/web/orderTracking/selectOrder',
      data: data,
      processData: false,
      contentType: false,
      enctype: 'multipart/form-data',
      success: resolve,
      error: reject,
      dataType: 'json'
    });
  })
}

// 入口函数，在页面加载完成后执行
function main() {
  Alpine.data('trackingOrder', function () {
    return {
      trackingFormData: {
        email: '',
        order_id: ''
      },
      isLoading: false,
      isDisabled: false,
      isMsgShow: false,
      hasData: false,
      dialogVisible: false, // 是否打开弹窗
      errMsg: '',
      detail: {},

      getBlurChange(e) {
        var el = e.target
        // 紧邻的兄弟元素
        var next = el.nextElementSibling
        // img
        var img = next.querySelector('img')
        img.src = img.getAttribute('data-src')
      },
      getFocusChange(e) {
        var el = e.target
        // 紧邻的兄弟元素
        var next = el.nextElementSibling
        // img
        var img = next.querySelector('img')
        img.src = img.getAttribute('hover-src')
      },
      closed() {
        this.dialogVisible = false
      },
      showErrMsg(msg) {
        this.errMsg = msg
        this.isMsgShow = true
      },
      /**
       * 提交表单
       * @param {MouseEvent} e
       * @returns 
       */
      submit(e) {
        e.preventDefault()
        if (this.isLoading) {
          return
        }

        this.isMsgShow = false
        this.errMsg = ''

        let valid = true

        // 订单号必填
        if (this.trackingFormData.order_id === '') {
          valid = false
          this.showErrMsg("Order ID is required")
          return
        }

        // 邮箱必填
        if (this.trackingFormData.email === '') {
          valid = false
          this.showErrMsg("Email is required")
          return
        }

        // 邮箱格式
        if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(this.trackingFormData.email)) {
          valid = false
          this.showErrMsg("Email address format is invalid")
          return
        }

        if (valid) {
          try {
            this.isLoading = true
            trackOrder(this.trackingFormData)
              .then((res) => {
                const { code, data, message } = res
                if (code === 400) {
                  this.isMsgShow = true
                  this.errMsg = message
                } else if (code === 200) {
                  this.dialogVisible = true
                  if (data !== '') {
                    this.hasData = true
                    this.detail = {
                      title: message,
                      ...data
                    }
                  } else {
                    this.hasData = false
                    this.detail = {
                      title: message
                    }
                  }
                }
              })
          } catch (e) {
            console.error(e)
          } finally {
            this.isLoading = false
          }
        }
      },
      toTrack(link) {
        window.open(link, '_blank')
      },

      orderError: "",
      checkOrder() {
        if (this.trackingFormData.order_id === '') {
          this.orderError = ("Order ID is required")
          return
        }

        this.orderError = ""
      },

      emailError: "",
      checkEmail() {
        if (this.trackingFormData.email === '') {
          this.emailError = ("Email is required")
          return
        }

        if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(this.trackingFormData.email)) {
          this.emailError = ("Email address format is invalid")
          return
        }

        this.emailError = ""
      },
      /**
       * 提交表单
       * @param {MouseEvent} e
       * @returns 
       */
      submitMobile(e) {
        e.preventDefault()
        if (this.isLoading) {
          return
        }

        this.isMsgShow = false
        this.errMsg = ''

        this.checkOrder()
        this.checkEmail()
        console.log("this.orderError", this.orderError);
        console.log("this.emailError", this.emailError);
        if (this.orderError || this.emailError) {
          return
        }

        try {
          this.isLoading = true
          trackOrder(this.trackingFormData)
            .then((res) => {
              const { code, data, message } = res
              if (code === 400) {
                this.isMsgShow = true
                this.errMsg = message
              } else if (code === 200) {
                this.dialogVisible = true
                if (data !== '') {
                  this.hasData = true
                  this.detail = {
                    title: message,
                    ...data
                  }
                } else {
                  this.hasData = false
                  this.detail = {
                    title: message
                  }
                }
              }
            })
        } catch (e) {
          console.error(e)
        } finally {
          this.isLoading = false
        }
      },
      toTrackMobile(link) {
        // window.open(link, '_blank')
        // 移动端需要使用location.href
        location.href = link
      }
    }
  })
}

document.addEventListener('alpine:init', main)
